export interface IChartTemplateTimeSessionMatches {
  id?: number;
  matchLabel?: string;
  matchStartTime?: string;
  tournamentDay?: number;
  chartTemplateTimeSessionId?: number;
}

export const defaultValue: Readonly<IChartTemplateTimeSessionMatches> = {};
